import { useSubscriptions } from './useSubscriptions'
import { OfferType } from '@/constants/wizard'
import { STRIPE_METADATA_TYPE, type StripeInterval } from '@/constants/subscription'
import { SubscriptionType } from '@/types/subscription'

interface UseSubscriptionPricesParams {
  offerType?: OfferType
}

export interface SubscriptionPrice {
  id: string
  amount: number
  currency: string
  interval: StripeInterval
}

export const useSubscriptionPrices = ({ offerType }: UseSubscriptionPricesParams) => {
  const { subscriptions, isLoading, isError, error } = useSubscriptions()

  const individualSubscriptions = subscriptions.filter(
    sub => sub.type === SubscriptionType.INDIVIDUAL
  )

  let filteredPrices: SubscriptionPrice[] = []

  if (offerType === OfferType.INTERN) {
    filteredPrices = individualSubscriptions
      .filter(sub => {
        const metadataType = sub.metadataType?.toLowerCase()
        return metadataType === STRIPE_METADATA_TYPE.INTERN.toLowerCase()
      })
      .map(sub => ({
        id: sub.price.id,
        amount: sub.price.amount,
        currency: sub.price.currency,
        interval: sub.interval,
      }))
  } else if (offerType === OfferType.PRACTITIONER) {
    filteredPrices = individualSubscriptions
      .filter(sub => {
        const metadataType = sub.metadataType?.toLowerCase()
        return (
          metadataType === STRIPE_METADATA_TYPE.MEDECIN.toLowerCase() ||
          metadataType === STRIPE_METADATA_TYPE.MEDECIN_ALT.toLowerCase()
        )
      })
      .map(sub => ({
        id: sub.price.id,
        amount: sub.price.amount,
        currency: sub.price.currency,
        interval: sub.interval,
      }))
  } else if (offerType === OfferType.MEMBER) {
    filteredPrices = individualSubscriptions
      .filter(sub => {
        const metadataType = sub.metadataType?.toLowerCase()
        return (
          metadataType === STRIPE_METADATA_TYPE.ADHERENT.toLowerCase() ||
          metadataType === STRIPE_METADATA_TYPE.ADHERENT_ALT.toLowerCase()
        )
      })
      .map(sub => ({
        id: sub.price.id,
        amount: sub.price.amount,
        currency: sub.price.currency,
        interval: sub.interval,
      }))
  }

  return {
    prices: filteredPrices,
    isLoading,
    isError,
    error,
  }
}
